module.exports = __webpack_public_path__ + "img/logo_1.e6c3c7b8.png";